export default __webpack_public_path__ + "7aac92f9b84e52c98fa9c4667432be73.png";